/*

    Module: jv.common.focus-on.directive
    Directive: jv-focus-on

    Simple directive to give element focus when expression is true.

    Usage:

        <input jv-focus-on="expression" [select-all] />

 */

angular.module('jv.common.focus-on.directive', [])
.directive('jvFocusOn', [
    '$timeout',
    function($timeout) {
        return {
            scope: {
                focus: '=jvFocusOn'
            },
            priority: 50,
            link: function(scope, element, attributes) {
                scope.$watch('focus', function(focus) {
                    var el = element[0];
                    if (focus) {
                        el.focus();
                        if (typeof attributes.selectAll !== 'undefined') {
                            el.selectionStart = 0;
                            el.selectionEnd = el.value.length;
                        }
                    }
                });
            }
        }
    }
]);